import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({ lines, as = "h1", className = "", delay = 0 }) => {
  const Tag = motion[as] || motion.h1;
  return (
    <Tag className={`uppercase ${className}`}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden">
          <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: 0 }}
            transition={{ duration: 1, delay: delay + i * 0.12, ease: [0.22, 1, 0.36, 1] }}
          >
            {i < lines.length - 1 ? `${line} ` : line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const SectionHeading = ({ number, kicker, title, light = false }) => (
  <Reveal className="mb-14 md:mb-20">
    <div className="flex items-baseline gap-6">
      <span className="font-mono-x text-xs" style={{ color: light ? "#31465A" : "#5B7F9E" }}>
        {number}
      </span>
      <p className="overline-x" style={light ? { color: "rgba(5,10,21,0.5)" } : {}}>{kicker}</p>
    </div>
    <h2
      className={`font-display font-800 tracking-tight uppercase text-3xl sm:text-4xl lg:text-5xl mt-5 max-w-3xl ${light ? "text-[#050A15]" : "text-white"}`}
      style={{ fontWeight: 800 }}
    >
      {title}
    </h2>
  </Reveal>
);
